import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    this.sortable = Sortable.create(this.containerTarget, {
      animation: 150,
      handle: "[data-sortable-handle]",
      draggable: "[data-nested-fields-target='row']",
      // Native HTML5 drag-and-drop is flaky on touch (iOS web view especially);
      // forceFallback uses SortableJS's own pointer-driven drag, which is the
      // reliable path on phones. fallbackTolerance stops a tap reading as a drag.
      forceFallback: true,
      fallbackTolerance: 4,
      ghostClass: "opacity-30",
      chosenClass: "recidex-sortable-chosen",
      onEnd: () => this.updatePositions()
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  updatePositions() {
    const rows = this.containerTarget.querySelectorAll("[data-nested-fields-target='row']")
    let position = 0
    let stepNumber = 1
    rows.forEach((row) => {
      if (row.style.display === "none") return
      const posInput = row.querySelector("input[name*='[position]']")
      if (posInput) posInput.value = position
      position++

      const isSection = row.querySelector("input[name*='[section_header]'][value='1']")
      const stepNum = row.querySelector("[data-step-number]")
      if (stepNum && !isSection) {
        stepNum.textContent = stepNumber++
      }
    })
  }
}
